// extracted by mini-css-extract-plugin
export var form = "styles-module--form--Xon5j";
export var field = "styles-module--field--2r45I";
export var splitLeft = "styles-module--split-left--3Mf-T";
export var splitRight = "styles-module--split-right--F3dNR";
export var label = "styles-module--label--1o287";
export var formButton = "styles-module--formButton--21WmJ";
export var fieldError = "styles-module--fieldError--2X1Ec";
export var active = "styles-module--active--1Vr8D";